var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFallingFrameLeft1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 991 958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbbcaa;}.cls-2{fill:#173856;}.cls-3{fill:#20456e;}.cls-4{fill:#639;}.cls-5{fill:#efa44b;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chute miroir") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chute_miroir",
    "data-name": "chute miroir"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1085.89,1260.84s20.48,72.29-23.27,69.13-33.31-70-33.31-70Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1079.3,1070.92s-38.73-75.85-87.89-14.11L1016.26,1268s44.71,14.52,78-4C1090.18,1188.83,1079.3,1070.92,1079.3,1070.92Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M980,1266.26l100.1-176.6s24.65-43.5-32.77-76.05-77.14,2.26-77.14,2.26l-105,185.31Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M658.09,1178.93s171.71-14.22,229.64,26C861.05,1237.33,884,1307.3,861,1310c-34,4-92.11-12.07-92.11-12.07s-80.24-20.45-121.32-10.38c0,0-6.67,7.84-16.15,8.19S574,1290.6,574,1290.6L589,1117.26S672.12,1113.86,658.09,1178.93Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M935.65,1312.74s-86.1,56.56-124.82,147.1c7.45,11.85-38.25,72.52-38.25,72.52l-141.5-95.28s27.91-58.92,82.06-29.19c23-49.9,98.7-172.8,152.86-206.89,26,15,90,44,114,59C986,1275,935.65,1312.74,935.65,1312.74Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1191.38,1147.91s67.62,32.76,36.17,63.35-74.41-21.64-74.41-21.64Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1045.13,1026.58s-82.41-21.49-69,56.27l174.27,121.82s40.57-23.75,48.89-60.91C1140.44,1096.84,1045.13,1026.58,1045.13,1026.58Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1074.07,1034.58c-5.8-7.2-14.17-14.41-26.07-21.15-57.42-32.55-78.88,1.27-78.88,1.27S994.5,1000.34,1074.07,1034.58Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 859.23,
    y: 1226.05,
    width: 132,
    height: 8,
    transform: "translate(615.66 2135.39) rotate(-150.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 499,
    cy: 210,
    r: 169
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1046.2,915l10,77.13s157-27.13,134-204.13c-13.94-107.25-110.8-146.53-194-140-26.27,2.06-70.79,18.2-101,41a196,196,0,0,0-49,55l103,42,58,81s27.67-26.15,54-14C1087.2,865,1081.2,919,1046.2,915Z",
    transform: "translate(-508 -621)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 991,
    height: 958
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallingFrameLeft1);
export default __webpack_public_path__ + "static/media/falling_frame_left_1.1c93871795293422c5d8a82fa7651134.svg";
export { ForwardRef as ReactComponent };